import { createContext } from "react";
import type { SettingsAt } from "@/domain/tenantPath";

/**
 * 설정 저장 위치 덮어쓰기 — 법인 환경설정(/c/{t}/settings)이 사업부 칩으로 고른 (법인, 사업부)를
 * 그 안의 편집 컴포넌트·훅에 내려준다(12 §8-C "저장 경로"). 객체만 둔다(Fast Refresh — Provider 는 쓰는 화면에서 바로).
 *
 * 없으면(null) 지금 공간(useSpace)의 법인·사업이 기준 — hooks/useTenantPath.ts `useSettingsAt()`.
 */
export const SettingsScopeContext = createContext<SettingsAt | null>(null);
